
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/products/[slug]",
      function () {
        return require("private-next-pages/[locale]/products/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/products/[slug]"])
      });
    }
  